import React, { useState } from 'react';

interface Product {
  id: number;
  title: string;
  category: string;
  description: string;
  features: string[];
  image: string;
  whatsappMessage: string;
}

const Products: React.FC = () => {
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [activeCategory, setActiveCategory] = useState<string>('todos');

  const products: Product[] = [
    {
      id: 1,
      title: "Equipos RX",
      category: "diagnostico",
      description: "Equipos de rayos X de alta calidad con más de 65 años de experiencia en el mercado. Tecnología avanzada con acreditaciones internacionales que avalan su calidad y funcionalidad.",
      features: [
        "Más de 65 años de experiencia en equipos de imagen",
        "Acreditaciones internacionales de calidad",
        "Red fortalecida de comercialización y servicio",
        "Línea de producción extensa"
      ],
      image: "/equiporx.jfif",
      whatsappMessage: "Hola, me interesa conocer más sobre los Equipos de RX Wandong. ¿Podrían enviarme información técnica y precios?"
    },
    {
      id: 2,
      title: "Mamógrafo Digital",
      category: "diagnostico",
      description: "Sistema de primera línea configurado para cualquier tipo de examen de mamografía digital, incluida la tomosíntesis. Fácilmente actualizable con técnicas de biopsia de vanguardia.",
      features: [
        "Mamografía digital con tomosíntesis",
        "Brazo en C isocéntrico",
        "Detector digital de campo completo",
        "Estación de trabajo integrada o separada",
        "Técnicas de biopsia de vanguardia"
      ],
      image: "/mamografo.jfif",
      whatsappMessage: "Hola, necesito información sobre el Mamógrafo Digital Helianthus DBT. ¿Pueden enviarme especificaciones técnicas y cotización?"
    },
    {
      id: 3,
      title: "Plataforma Tecnológica",
      category: "software",
      description: "Sistema de gestión de imágenes médicas con tecnología de transmisión ultrarrápida. Diseño fácil de usar con interfaz totalmente personalizable y herramientas analíticas avanzadas.",
      features: [
        "Transmisión ultrarrápida en cualquier ancho de banda",
        "Interfaz de usuario totalmente personalizable",
        "Comparación entre estudios actuales y anteriores",
        "Visualización de imágenes en cualquier lugar",
        "Herramientas colaborativas avanzadas"
      ],
      image: "/software.jfif",
      whatsappMessage: "Hola, me interesa la Plataforma PACS/RIS para mi centro médico. ¿Podrían brindarme una demostración y cotización?"
    }
  ];

  const categories = [
    { id: 'todos', name: 'Todos los Productos' },
    { id: 'diagnostico', name: 'Diagnóstico por Imagen' },
    { id: 'software', name: 'Software Médico' }
  ];

  const filteredProducts = activeCategory === 'todos' 
    ? products 
    : products.filter(product => product.category === activeCategory);

  const handleWhatsAppClick = (message: string) => {
    const phoneNumber = '+593969372133';
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  const openProductModal = (product: Product) => {
    setSelectedProduct(product);
  };

  const closeProductModal = () => {
    setSelectedProduct(null);
  };

  return (
    <section id="productos" className="products">
      <div className="products-container">
        <h2 className="section-title">Equipos de Diagnóstico por Imagen</h2>
        <p className="products-subtitle">
          Tecnología médica de vanguardia para centros de salud, hospitales y clínicas especializadas
        </p>
        
        {/* Category Filter */}
        <div className="category-filter">
          {categories.map(category => (
            <button
              key={category.id}
              className={`category-btn ${activeCategory === category.id ? 'active' : ''}`}
              onClick={() => setActiveCategory(category.id)}
            >
              {category.name}
            </button>
          ))}
        </div>

        {/* Products Grid */}
        <div className="products-grid-new">
          {filteredProducts.map(product => (
            <div key={product.id} className="product-card-new">
              <div className="product-image">
                <img src={product.image} alt={product.title} className="product-icon" />
              </div>
              <div className="product-info">
                <h3 className="product-title">{product.title}</h3>
                <p className="product-description">{product.description}</p>
                <div className="product-actions">
                  <button 
                    className="btn-secondary"
                    onClick={() => openProductModal(product)}
                  >
                    Ver Detalles
                  </button>
                  <button 
                    className="btn-primary"
                    onClick={() => handleWhatsAppClick(product.whatsappMessage)}
                  >
                    Conoce Más
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Product Modal */}
      {selectedProduct && (
        <div className="product-modal-overlay" onClick={closeProductModal}>
          <div className="product-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeProductModal}>×</button>
            <div className="modal-header">
              <img src={selectedProduct.image} alt={selectedProduct.title} className="modal-icon" />
              <h3>{selectedProduct.title}</h3>
            </div>
            <div className="modal-content">
              <p>{selectedProduct.description}</p>
              <h4>Características principales:</h4>
              <ul className="features-list">
                {selectedProduct.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>
            <div className="modal-actions">
              <button 
                className="btn-primary-modal"
                onClick={() => handleWhatsAppClick(selectedProduct.whatsappMessage)}
              >
                Solicitar Información por WhatsApp
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Products;
